// @flow

import { useTranslator } from '@gandi/translate';
import { Base, Spinner } from '@gandi/ui';

export function FetchingRow(): React.MixedElement {
  const { __ } = useTranslator();

  return (
    <Base flex flexGrow1 gap="small" marginBottom="base" flexAlignItemsCenter>
      {__('We are checking if you have domains or hosting to renew.')}
      <Spinner name="dots" variant="small" />
    </Base>
  );
}
